/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_N8n_Scope_Point_2Inputs */

const en_svc_n8n_scope_point_2 = /** @type {(inputs: Svc_N8n_Scope_Point_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI steps for classification, data extraction and drafting`)
};

const lv_svc_n8n_scope_point_2 = /** @type {(inputs: Svc_N8n_Scope_Point_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI soļi klasificēšanai, datu ieguvei un tekstu sagatavošanai`)
};

/**
* | output |
* | --- |
* | "AI steps for classification, data extraction and drafting" |
*
* @param {Svc_N8n_Scope_Point_2Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_n8n_scope_point_2 = /** @type {((inputs?: Svc_N8n_Scope_Point_2Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_N8n_Scope_Point_2Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_n8n_scope_point_2(inputs)
	return en_svc_n8n_scope_point_2(inputs)
});